@if (loadingModel.isLoading) {
  <span class="ui-loading" [model]="loadingModel"></span>
} @else {
  @if (isQueryPresent && !loading) {
    <div style="height: 100%" class="query-renderer-wrap">
      @if (noData) {
        <div class="query-renderer-no-data">{{'component.queryRenderer.noData' | translate}}</div>
      } @else {
        @if (chartType !== 'table' && chartType !== 'number') {
          <div
            class="chart-container"
            >
            @if (chartType === 'line') {
              <canvas
                baseChart
                legend="true"
                [type]="'line'"
                [datasets]="chartData"
                [labels]="chartLabels"
                [options]="noFillChartOptions"
                >
              </canvas>
            }
            @if (chartType === 'area') {
              <canvas
                baseChart
                legend="true"
                [type]="'line'"
                [datasets]="chartData"
                [labels]="chartLabels"
                [options]="chartOptions"
                >
              </canvas>
            }
            @if (chartType === 'bar') {
              <canvas
                baseChart
                legend="true"
                [type]="'bar'"
                [datasets]="chartData"
                [labels]="chartLabels"
                [options]="chartOptions"
                [class]="itemHovered"
                >
              </canvas>
            }
            @if (chartType === 'pie') {
              <canvas
                baseChart
                legend="true"
                [type]="'pie'"
                [datasets]="chartData"
                [labels]="chartLabels"
                [options]="chartOptions"
                >
              </canvas>
            }
          </div>
        }
        @if (chartType === 'table') {
          <table
            mat-table
            [dataSource]="tableData"
            style="width: 100%"
            >
            @for (column of displayedColumns; track column; let index = $index) {
              <ng-container [matColumnDef]="column" >
                <th mat-header-cell *matHeaderCellDef>{{ columnTitles[index] }}</th>
                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        }
        @if (chartType === 'number') {
          <div class="numeric-container">
            @for (value of numericValues; track value) {
              <h2>{{ value | number }}</h2>
            }
          </div>
        }
      }
    </div>
  }
}
